<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="1">
        <v-btn icon @click="back" :disabled="firstPage">
          <v-icon>mdi-arrow-left</v-icon></v-btn
        >
      </v-col>
      <v-col cols="10"><slot></slot></v-col>
      <v-col cols="1">
        <v-btn icon @click="forth" :disabled="lastPage">
          <v-icon>mdi-arrow-right</v-icon></v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { pagelist } from "@/store/index";
const number_of_pages = pagelist.length;

export default {
  name: "NavigationComponent",

  methods: {
    back() {
      this.$store.commit("decr_page");
    },
    forth() {
      this.$store.commit("incr_page");
    }
  },

  computed: {
    firstPage() {
      return this.$store.state.page == 0;
    },
    lastPage() {
      return this.$store.state.page == number_of_pages - 1;
    }
  }
};
</script>

<style scoped></style>
